import EventsWrapper from 'hb-builder/components/BuilderComponents/dynamic/EmailList/EmailListLayouts/EventsWrapper';
import NewsWrapper from 'hb-builder/components/BuilderComponents/dynamic/EmailList/EmailListLayouts/NewsWrapper';
import type { EmailListProps } from 'hb-builder/components/BuilderComponents/dynamic/EmailList/types';
import EmptyDynamicState from 'hb-builder/components/common/state/EmptyDynamicState';
import ErrorState from 'hb-builder/components/common/state/ErrorState';
import { useGetDynamicSearch } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicSearch';
import { APP_TYPE } from 'hb-react/types/appType';

const SelectedLayout = {
  events: EventsWrapper,
  news: NewsWrapper,
};

const EmailListLayouts = ({ app, dynamicAttributes, type }: EmailListProps) => {
  const isBackOffice = app === APP_TYPE.BACKOFFICE;

  const params = {
    query: {
      categories: dynamicAttributes?.query.categories,
      page: 1,
      per_page: dynamicAttributes?.query.numberOfItems,
      total_items: dynamicAttributes?.query.numberOfItems,
      type: dynamicAttributes?.query.dataType,
    },
  };

  const { data, error, isError, isLoading } = useGetDynamicSearch({
    app,
    params,
    type,
  });

  if (isError) {
    return isBackOffice ? <ErrorState error={error} /> : null;
  }

  if (data?.length === 0 && !isLoading) {
    return isBackOffice ? (
      <EmptyDynamicState component="list" type={type} />
    ) : null;
  }

  const Layout = SelectedLayout[type];

  const customProps = {
    events: {
      data,
      dynamicAttributes,
      isLoading,
    },
    news: {
      data,
      dynamicAttributes,
      isLoading,
    },
  };

  return <Layout {...customProps[type]} />;
};

export default EmailListLayouts;
